import {Card, Col, Form, Row} from "react-bootstrap";
import React, {useState} from "react";
import graphql from "babel-plugin-relay/macro";
import * as yup from "yup";
import {useFragment, useMutation} from "react-relay";
import {FormProvider, useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import {useUser} from "../../hooks/useUser";
import {toast} from "react-toastify";
import IconButton from "../../components/common/IconButton";
import {createOptions} from "../../helpers/utils";
import HorizontalFormSelect from "../../components/common/horizontal-form-inputs/HorizontalFormSelect";

const DataImporter = ({className, color, icon, amount, title, attachments}) => {
    const DataImporterMutation = graphql`
        mutation DataImporterMutation($attachmentId: ID!) {
             legalContract {
                 importContractData (input: {attachmentId: $attachmentId}) {
                    legalContract {
                        id
                        name
                    }
                 }
             }
        }
    `
    const data = useFragment(graphql`
        fragment DataImporter_Attachments on Attachment @relay(plural:true) {
            id
            fileName
            size
            lastModifiedTimestampUtc
            downloadUrl
            category {
                id
                name
            }
        }`, attachments);
    const attachmentOptions = createOptions(data, "id", "fileName");
    const schema = yup.object({
        attachmentId: yup.string().required(),
    })
    const defaultValues = {
        attachmentId: "",
    }
    const [readMode, setReadMode] = useState(true);
    const [commitMutation, isInFlight] = useMutation(DataImporterMutation);
    const methods = useForm({values: defaultValues, resolver: yupResolver(schema)})
    const {hasPermission} = useUser();
    const onSubmit = (data) => {
        commitMutation({variables: {
                ...data
            }, onCompleted: (data) => {
                if(data.legalContract) {
                    toast.success("Import completed")
                }
            }})
    }
    return (
        <FormProvider {...methods}>
            <Card className="mb-3">
                <Card.Header>
                    <Row className="flex-between-center">
                        <Col xs={4} sm="auto" className="d-flex align-items-center pe-0">
                            <h2 className="h5 fs-0 mb-0 text-nowrap py-2 py-xl-0">Data Import</h2>
                        </Col>
                    </Row>
                </Card.Header>
                <Card.Body>
                    <Form noValidate onSubmit={methods.handleSubmit(onSubmit)}>
                        <Row>
                            <Col>
                                <HorizontalFormSelect controlId={"attachmentId"} label={"File to import"} options={attachmentOptions}/>
                                <IconButton
                                    iconClassName="fs--2 me-1"
                                    variant="falcon-default"
                                    size="sm"
                                    icon="check"
                                    disabled={isInFlight}
                                    type={"submit"}
                                >
                                    {isInFlight ? "Importing" : "Import"}
                                </IconButton>
                            </Col>
                        </Row>
                    </Form>
                </Card.Body>
                <Card.Footer>
                </Card.Footer>
            </Card>
        </FormProvider>
    )
}
export default DataImporter;